module.exports = __webpack_public_path__ + "static/media/2023-SWG-Uni-Student-Comp-Banner-min.cee0dffe.jpg";